import { render, staticRenderFns } from "./teamTableNfl.vue?vue&type=template&id=a9a65822&scoped=true"
import script from "./teamTableNfl.vue?vue&type=script&lang=js"
export * from "./teamTableNfl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a65822",
  null
  
)

export default component.exports